import { DeleteFilled } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';

const RemoveInput = ({ value, onRemove }) => (
  <Tooltip title="Remove">
    <Button
      danger
      icon={<DeleteFilled />}
      onClick={() => onRemove(value)}
    />
  </Tooltip>
);

export default RemoveInput;
